import { UI, DayFlag, SelectionState, Animation } from "../UI.js";
/**
 * Get the default class names for the UI elements.
 *
 * @group Utilities
 */
export function getDefaultClassNames() {
  var classNames = {};
  for (var key in UI) {
    classNames[UI[key]] = "rdp-".concat(UI[key]);
  }
  for (var _key in DayFlag) {
    classNames[DayFlag[_key]] = "rdp-".concat(DayFlag[_key]);
  }
  for (var _key2 in SelectionState) {
    classNames[SelectionState[_key2]] = "rdp-".concat(SelectionState[_key2]);
  }
  for (var _key3 in Animation) {
    classNames[Animation[_key3]] = "rdp-".concat(Animation[_key3]);
  }
  return classNames;
}